const ON_START_NO_DEFINED = "api/ON_START_NO_DEFINED";
const ON_COMPLETE_NO_DEFINED = "api/ON_COMPLETE_NO_DEFINED";
const ON_END_NO_DEFINED = "api/ON_END_NO_DEFINED";
const ON_ERROR_NO_DEFINED = "api/ON_ERROR_NO_DEFINED";
export default {
    ON_COMPLETE_NO_DEFINED,
    ON_END_NO_DEFINED,
    ON_ERROR_NO_DEFINED,
    ON_START_NO_DEFINED
}